import React, { useState } from "react";
import { TableCell, Tooltip, IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const DnDropdownCell = ({ singleRow, onViewSingleContractDns,classes }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = (type) => {
    handleClose();
    onViewSingleContractDns(type,singleRow);
  };

  return (
    <>
      <Tooltip title="View Single Account DNs" enterDelay={300}>
        <IconButton onClick={handleClick} size="small">
          <MoreVertIcon />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
                <MenuItem onClick={() => handleMenuClick("lost")}>
        Irrelavent DNs
        </MenuItem>
        <MenuItem onClick={() => handleMenuClick("mismatch")}>
          Mismatch DNs
        </MenuItem>
      </Menu>
    </>


  );
};

export default DnDropdownCell;
